.manage-modal {
  height: 900px;
  width: 480px;
}

.manage-modal-body {
  height: 100%;
}
